<template>
  <div>
    <button
      class="button toggle"
      @click="toggle"
      :class="[firstactive ? 'active' : '']"
    >{{label1}}</button>
    <button
      class="button toggle"
      @click="toggle"
      :class="[!firstactive ? 'active' : '']"
    >{{label2}}</button>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "LToogleButton",
    props: ["label1", "label2", "firstactive"],
    data() {
      return {
      };
    },
    methods: {
        toggle(){
            this.firstactive = !this.firstactive;
        }
    }
  };
  </script>
  
  <style lang="postcss">
      .button{
        background-color: lightgrey;
        width: 75px;
        height: 30px;
        border-radius: 5%;
/*         margin: 5px; */
      }
      .active{
        background-color: cadetblue;
      }
      
  </style>
  